import { action, observable, runInAction } from 'mobx';

import { ErrorInterface } from 'modules/core/api/globalApi';
import { printingController } from './printingController';
import {
  PrintingDocument,
  FailedItemInterface,
  GenerateAndSendLinksRequestInterface,
  SendDocSmsRequestInterface,
  SendDocSmsResponseInterface,
  // SignedDocUrlItemInterface,
  SignedDocInterface,
} from '../../api/printingApi';

import { SERVICE_61_EXPERT_APPOINTMENT } from 'modules/core/constants/services';
// import { PriceResponse } from '../../../scheduler/api/priceCalculateApi';

/* type TireModelsCacheType = {
  tireModels: TireModelInterface[],
  brandId: number,
}; */
export interface PrintingStore {
  printingDocuments: PrintingDocument[],
  printingDocumentsByOrderId: string,
  failedItems: FailedItemInterface[],
  placeholders: any, // тут объект со всеми плайсхолдерами
  waitingSmsResponse: boolean,
  alreadySendedSms: boolean,
  docSmsResponse: SendDocSmsResponseInterface,
  docSmsError: ErrorInterface,
  signedDocUrls:SignedDocInterface[],
  signedDocUrlsByOrderId: string,
  error: ErrorInterface,
}

export const printingStore: PrintingStore = observable({
  printingDocuments: [],
  printingDocumentsByOrderId: undefined,
  failedItems: [],
  placeholders: {},
  waitingSmsResponse: false,
  alreadySendedSms: false,
  docSmsResponse: null,
  docSmsError: null,
  signedDocUrls: [],
  signedDocUrlsByOrderId: null,
  error: null,
} as PrintingStore);

export const printingActions = {

  getPrintingDocumentsResponse: async (orderId:string, serviceId: number): Promise<void> => {
    printingStore.error = null;
    printingStore.printingDocumentsByOrderId = orderId;
    const response = await printingController.getPrintingDocumentsResponse(orderId);

    // const response1 = await printingController.getPrintingInsuranceDocumentsResponse(orderId);
    // только для 61 сервиса печатаем акт ПП
    // бэк убеждат, что так правильно
    // я предлагал на бэке в едином методе определить, какие бланки надо печатать
    const response1 = serviceId === SERVICE_61_EXPERT_APPOINTMENT 
      ? await printingController.getPrintingInsuranceDocumentsResponse(orderId) 
      : [];
        
    printingActions.handleError(response);

    // const x = [...response?.data?.items ?? [], { name: response1?.data?.name, fileUrl: response1?.data?.fileUrl }];

    const x = serviceId === SERVICE_61_EXPERT_APPOINTMENT
      ? [...response?.data?.items ?? [], { name: response1?.data?.name, fileUrl: response1?.data?.fileUrl }]
      : [...response?.data?.items ?? []];

    if (!response.errorData) {
      runInAction(() => {
        printingStore.printingDocuments = x ?? [];
        printingStore.failedItems = response?.data?.failedItems ?? [];
      });
    }
  },

  getPrintingDocumentsActOfReturnResponse: async (orderId:string): Promise<void> => {
    printingStore.error = null;
    printingStore.printingDocumentsByOrderId = orderId;
    const response = await printingController.getPrintingDocumentsActOfReturnResponse(orderId);
    printingActions.handleError(response);
    if (!response.errorData) {
      runInAction(() => {
        printingStore.printingDocuments = response?.data?.items ?? [];
        printingStore.failedItems = response?.data?.failedItems ?? [];
      });
    }
  },

  getPlaceholders: async (orderId:string): Promise<void> => {
    printingStore.error = null;
    const response = await printingController.getPlaceholders(orderId);
    printingActions.handleError(response);
    if (!response.errorData) {
      runInAction(() => {
        printingStore.placeholders = response?.data ?? {};
      });
    }
  },

  generateAndSendLinks: async (orderId:string, request: GenerateAndSendLinksRequestInterface): Promise<void> => {
    printingStore.error = null;
    const response = await printingController.generateAndSendLinks(orderId,request);
    printingActions.handleError(response);
  },

  sendDocSms: async (request: SendDocSmsRequestInterface): Promise<void> => {
    printingStore.error = null;
    runInAction(() => {
      printingStore.waitingSmsResponse = true;
    });
    try {
      const response = await printingController.sendDocSms(request);
      // printingActions.handleError(response);
      if (!response.error) {
        runInAction(() => {
          printingStore.docSmsResponse = response?.data ?? {};
        });
      }
      else {
        runInAction(() => {
          const { data } = response;
          printingStore.docSmsError = data;
          //      throw data;
        });
      }
    } finally{
      runInAction(() => {
        printingStore.waitingSmsResponse = false;
      });

    };
  },

  clearDocSmsResponse: action(() => {
    printingStore.docSmsResponse = null;
    printingStore.docSmsError = null;
    // printingStore.alreadySendedSms = false;
  }),

  clearPrintingDocuments: action(() => {
    printingStore.printingDocuments = [];
    printingStore.printingDocumentsByOrderId = undefined;
    printingStore.failedItems = [];
    printingStore.error = null;
  }),

  getSignedDocUrls: async (orderId:string): Promise<void> => {
    printingStore.error = null;
    printingStore.signedDocUrlsByOrderId = orderId;
    const response = await printingController.getSignedDocUrls(orderId);
    printingActions.handleError(response);
    if (!response.errorData) {
      runInAction(() => {
        printingStore.signedDocUrls = response?.data?.items ?? [];
      });
    }
  },

  setAlreadySendedSms: async (request: boolean): Promise<void> => {
    runInAction(() => {
      printingStore.alreadySendedSms = request;
    });
  },

  clearSignedDocUrls: action(() => {
    printingStore.signedDocUrls = [];
    printingStore.signedDocUrlsByOrderId = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { data } = response;
      printingStore.error = data;
      throw data;
    }
  }),

};
